import React from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import FilterRow from './FilterRow';
import useFilters from './useFilters';

const FilterableTable = ({
  tableName,
  columns,
  action,
  rows,
  totalElements,
  filterPosition,
}) => {
  const {
    handleFilterChange,
    rowPerPage,
    handleRowPerPageChange,
    page,
    handlePageChange,
  } = useFilters({
    columns,
    action,
  });

  return (
    <>
      <TableContainer style={{ height: '400px' }}>
        <TableRow style={{ textAlign: 'center' }}>
         {tableName && <Typography variant="h5" color={'#1f4f82'}>
            {tableName}
          </Typography>}
        </TableRow>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <FilterRow
              filterPosition={filterPosition}
              columns={columns}
              handleFilterChange={handleFilterChange}
            ></FilterRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
      <div className="pagination-container">
        <TablePagination
          className="pagination-content"
          rowsPerPageOptions={[10, 20, 30, 40]}
          rowsPerPage={rowPerPage}
          labelRowsPerPage={'Број редова у приказу'}
          page={page}
          count={totalElements}
          component={'div'}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowPerPageChange}
        ></TablePagination>
      </div>
    </>
  );
};

export default FilterableTable;
